import { AttendanceTab } from '~pages/classes/class-analytics-dashboard/attendance-tab';
import { MetricStrip } from '~pages/classes/class-analytics-dashboard/metric-strip';
import { SessionsTab } from '~pages/classes/class-analytics-dashboard/sessions-tab';
import { StudentsTab } from '~pages/classes/class-analytics-dashboard/students-tab';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~shared/shadcn/ui/tabs';

// const Columns = [columnHelper.accessor('', 'Class Name')];

export function ClassAnalyticsDashboard({ classId }: { classId: string }) {
  return (
    <div className='flex min-h-screen w-full flex-col'>
      {/* Header and overview cards remain unchanged */}
      <div className='flex flex-col sm:gap-4'>
        {/* Class Overview */}
        <div className='mt-4'>
          {/* Overview cards section remains unchanged */}
          <MetricStrip classId={classId} />

          <Tabs defaultValue='attendance'>
            <TabsList className='mb-4'>
              <TabsTrigger value='attendance'>Attendance</TabsTrigger>
              <TabsTrigger value='students'>Students</TabsTrigger>
              <TabsTrigger value='sessions'>Sessions</TabsTrigger>
            </TabsList>

            {/* Attendance Tab */}
            <TabsContent value='attendance' className='space-y-4'>
              <AttendanceTab classId={classId} />
            </TabsContent>

            {/* Students Tab content remains unchanged */}
            <TabsContent value='students' className='space-y-4'>
              <StudentsTab classId={classId} />
            </TabsContent>

            {/* Sessions Tab */}
            <TabsContent value='sessions' className='space-y-4'>
              <SessionsTab classId={classId} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
